<script>
import { dropdownIcon } from '@/utils/helpers';
import Selectable from '../../mixins/Selectable';
import Clearable from '../../mixins/Clearable';
import CheckboxGridPicker from '../pickers/CheckboxGridPicker.vue';
import Messages from '../../../enums/Messages';
import TextFormatter from '../../../formatters/TextFormatter';

export default {
  name: 'CheckboxGroupDropdown',
  components: {
    CheckboxGridPicker,
  },
  mixins: [Selectable, Clearable],
  props: {
    label: {
      type: String,
      default: '',
    },

    allText: {
      type: String,
      default: Messages.ALL,
    },

    actionGroups: {
      type: Array,
      default: () => [],
    },
    minWidth: {
      type: Number,
      default: 219,
    },
    maxWidth: {
      type: Number,
      default: 600,
    },
  },
  data() {
    return {
      picker: false,
      closeOnClick: true,
      closeOnContentClick: false,
      messages: Messages,
    };
  },
  computed: {
    textFieldValue() {
      if (this.selected.length && this.selected.length !== this.allValues.length) {
        return TextFormatter.selectedMultipleItems(this.selected.length);
      }
      return this.allText;
    },

    appendIcon() {
      return dropdownIcon(this.picker);
    },
  },
};
</script>

<template>
  <v-menu
    ref="picker"
    v-model="picker"
    :close-on-click="closeOnClick"
    :close-on-content-click="closeOnContentClick"
    transition="scale-transition"
    :min-width="minWidth"
    :max-width="maxWidth"
    offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="textFieldValue"
        :label="label"
        dense
        hide-details
        outlined
        readonly
        v-on="on"
        :append-icon="appendIcon"
        @click:append="picker = !picker"
        v-bind="attrs"
      ></v-text-field>
    </template>
    <checkbox-grid-picker
      v-model="selected"
      :options="options"
      :clearable="clearable"
      :select-all="selectAll"
      :action-groups="actionGroups"
      :cols="3"
      class="pa-2 px-3"
    >
      <template v-slot:actions>
        <v-btn text color="primary" @click="picker = false">{{ messages.CLOSE }}</v-btn>
      </template>
    </checkbox-grid-picker>
  </v-menu>
</template>
